import { Icon } from '@blueprint/ui';
import React, { useState } from 'react';
import { ContactLink, ContactReveal } from '../ListingCard.styles';

type PhoneNumberProps = {
    phoneNumber: string;
    phoneOnClick?: () => void;
    phoneRevealOnClick?: () => void;
    isPhoneClickToRevealEnabled: boolean;
};

const PhoneNumber = ({
    phoneNumber,
    phoneOnClick,
    phoneRevealOnClick,
    isPhoneClickToRevealEnabled
}: PhoneNumberProps) => {
    const [clicked, setClicked] = useState<boolean>(false);

    const displayNumber = () => {
        setClicked(true);
        phoneRevealOnClick?.();
    };

    if (isPhoneClickToRevealEnabled === false || clicked)
        return (
            <ContactLink
                href={`tel:${phoneNumber}`}
                onClick={phoneOnClick}
                variant="tertiary"
                data-testid="agent-phone-number"
            >
                <Icon iconId="phone_outline" size="medium" />
                {phoneNumber}
            </ContactLink>
        );

    return (
        <ContactReveal
            onClick={displayNumber}
            variant="tertiary"
            data-testid="agent-phone-number-revealer"
        >
            <Icon iconId="phone_outline" size="medium" />
            {'Call'}
        </ContactReveal>
    );
};

export default PhoneNumber;
